import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import { getNonEmpty } from '../../../../utils/helpers';
import { alertError, alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
    dateFormatter,
} from "../../../components/tables/table";
import { buttonFormatterEditDelete, buttonFormatterEditDisableDelete } from "../../../components/tables/buttonFormatterTable";
import { deleteProjectTitle, getAllActiveProjectTitles } from "../../../../api/projectTitles";

export default function ProjectTitlesPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
    const [refresh, setRefresh] = useState(false)
    const [data, setData] = useState([])
    const [projectTitle, setProjectTitle] = useState(null);

    useEffect(() => {
        getAllActiveProjectTitles()
            .then((res) => {
                const data = res.data.map(item => ({
                    ...item,
                    title: getNonEmpty(item.title),
                    id: item._id,
                }))
                setData(data);
                setRefresh(false);
            })
            .catch(error => {
                alertError({ error: error, customMessage: 'Could not get project titles.' })
            })
    }, [refresh]);


    const columns = [
        { dataField: "title", text: "Title", sort: true },
        {
            dataField: "typeTech", text: "Technology type", sort: true,
            formatter: (cell) => cell.charAt(0).toUpperCase() + cell.slice(1)
        },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true,
        },
        {
            dataField: "id", text: "",
            formatter: (cell, row) => buttonFormatterEditDelete(cell, "projectTitle", data, row?.active, setProjectTitle, setOpenConfirmDialog, history),
            headerStyle: { width: '200px' }
        }
    ];

    return (
        <>
            <Card>
                <CardHeader title="Project titles list">
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-primary text-white"
                            onClick={() => history.push("/edit-projectTitle")}
                        >
                            Add new
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    <Table data={data} columns={columns} key={data.length} />

                    <ConfirmDialog
                        title={"Are you sure you want to delete this project title?"}
                        open={openConfirmDialog === 2}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteProjectTitle(projectTitle.id)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Project title deleted successfully.",
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the project title.",
                                    });
                                });
                        }}
                    />
                </CardBody>
            </Card>
        </>
    );
}